var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCirclePrime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM17.2071 10.2071C17.5976 9.81658 17.5976 9.18342 17.2071 8.79289C16.8166 8.40237 16.1834 8.40237 15.7929 8.79289L11 13.5858L9.20711 11.7929C8.81658 11.4024 8.18342 11.4024 7.79289 11.7929C7.40237 12.1834 7.40237 12.8166 7.79289 13.2071L10.2929 15.7071C10.4804 15.8946 10.7348 16 11 16C11.2652 16 11.5196 15.8946 11.7071 15.7071L17.2071 10.2071Z",
    fill: "#0D7A25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCirclePrime);
export default __webpack_public_path__ + "static/media/check-circle-prime.9ccdddafa28287215b41103e4d52038f.svg";
export { ForwardRef as ReactComponent };